import ENDPOINT from "@/api/endpoints";
import { HTTP, HTTP_FILE } from "@/api/http-common";

export function callApiLayDanhSachBaoCaoTable(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.BAO_BAO.DANH_SACH_BAO_CAO, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDownloadExportBaoCao(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(ENDPOINT.BAO_BAO.DOWNLOAD_EXPORT, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDownloadExportThongKeBaoCaoVbd(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.BAO_BAO.DOWNLOAD_THONG_KE_EXPORT_VBD,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDownloadExportBaoCaoVanBanDi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(ENDPOINT.BAO_BAO.DOWNLOAD_EXPORT_VAN_BAN_DI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiBaoCaoVanBanDi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.BAO_BAO.DANH_SACH_BAO_CAO_VAN_BAN_DI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiBaoCaoChuyenDoiSo(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.BAO_BAO.CHUYEN_DOI_SO, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiBaoCaoChuyenDoiSoChiTiet(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.BAO_BAO.CHUYEN_DOI_SO_CHI_TIET, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiBaoCaoNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.BAO_BAO.NHIEM_VU_GIAO_BO, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callDanhSachNgoaiHeThong(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.BAO_BAO.DON_VI_NGOAI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
